const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const DeliveryQuery: any = {
    GetStoreShippingCompanyMappings: Backofficebff + '/v1/deliveryservice/get-store-shipping-company-mappings',
    GetCargoStoreShippingCompanyMapping: Backofficebff + '/v1/deliveryservice/get-cargo-store-shipping-company-mapping',
    GetBlockedShippingCompanyForCustomerHistory: Backofficebff + '/v1/deliveryservice/get-blocked-shipping-company-for-customer-history',
    GetCustomerShippingCompanyChangeHistory: Backofficebff + '/v1/deliveryservice/get-customer-shipping-company-change-history',
};
